<!--
 * @FileDescription: 客户优惠券
 * @Author: 陈文景
 * @Date: 2023-03-09 14:34:26
 * @LastEditors: 最后更新作者
 * @LastEditTime: 最后更新时间
-->
<template>
  <PageSkeletonTwo>
    <template slot="header-left">
      <el-input placeholder="请输入内容" v-model="parameter.searchContent" clearable size="medium" class="input-with-select" @clear="getCustomerCouponsList">
        <el-select v-model="parameter.searchType" slot="prepend" placeholder="请选择" style="width:130px;">
          <el-option label="客户名" :value="0" />
          <el-option label="邮箱/手机号" :value="1"/>
        </el-select>
        <el-button slot="append" icon="el-icon-search" @click="getCustomerCouponsList" />
      </el-input>

      <el-input v-model="parameter.couponTicketName" clearable size="medium" placeholder="优惠券ID/名称" @clear="getCustomerCouponsList">
        <el-button slot="append" icon="el-icon-search" @click="getCustomerCouponsList" />
      </el-input>

      <div class="select-picker">
        <el-select v-model="parameter.dateType" size="medium" placeholder="请选择">
          <el-option label="领取时间" :value="1" />
        </el-select>
        <el-date-picker v-model="parameter.dataTime" size="medium" type="datetimerange" range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" value-format="timestamp" @change="changeDatePicker" />
      </div>
    </template>

    <template slot="container">
      <el-table v-loading="loading" :data="coupons" row-key="id" style="width: 100%">
        <el-table-column label="客户名" prop="userName" show-overflow-tooltip fixed="left" />
        <el-table-column prop="showName" label="邮箱/手机号" show-overflow-tooltip />
        <el-table-column label="优惠券名称" prop="couponTicketName" show-overflow-tooltip />
        <el-table-column label="领取时间" show-overflow-tooltip>
          <template v-slot="{ row }">
            {{ defaultTips(formatTimeStamp(row.createDate)) }}
          </template>
        </el-table-column>
        <el-table-column label="用券时间" show-overflow-tooltip>
          <template v-slot="{ row }">
            {{ defaultTips(formatTimeStamp(row.useTime)) }}
          </template>
        </el-table-column>
        <el-table-column label="领取来源" show-overflow-tooltip>
          <template v-slot="{ row }">
            {{ getReceiveSource(row.receiveSource) }}
          </template>
        </el-table-column>
        <el-table-column label="状态">
          <template v-slot="{ row }">
            {{ getState(row.status) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="120">
          <template v-slot="{ row }">
            <a v-if="row.status === 0" href="javascript:;" @click="() => onStopCustomerCoupon(row)">停止客户用券</a>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </el-table>
    </template>

    <template #footer-right>
      <el-pagination background :current-page="parameter.pageNumber" :page-sizes="[20, 50, 100, 200, 500]" :page-size="parameter.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" class="el-pagination" @size-change="onSizeChange" @current-change="onCurrentChange" />
    </template>
  </PageSkeletonTwo>
</template>

<script>
import API from '@/api'
import { formatTimeStamp } from '@/utils/moment'
import PageSkeletonTwo from './components/PageSkeletonTwo.vue'

let parameter = {
  searchType: 0, // 搜索用户信息类型：0.用户名 1.邮箱
  searchContent: undefined, // 搜索内容
  couponTicketName: undefined, // 优惠券名称
  dateType: 1, // 日期的搜索类型（请求前需要删除）
  dataTime: null, // 日期选择器双向绑定的值（请求前需要删除）
  pickUpTimeStar: undefined, // 领取时间 - 开始
  pickUpTimeEnd: undefined, // 领取时间 - 结束
  pageNumber: 1,
  pageSize: 20
}

export default {
  name: 'operation_customer',
  components: {
    PageSkeletonTwo
  },
  data() {
    return {
      formatTimeStamp,

      parameter: { ...parameter },

      // 搜索条件
      searchOptins: [
        { label: '客户名', value: 1 },
        { label: '邮箱', value: 2 }
      ],

      coupons: [
        // { id: 1, userName: 'Otilia', email: 'Xtremewnyhoney@gmail.com', couponTicketName: 'Christmas', pickUpTime: 1678344436103, useTime: 1678344436103, receiveSource: 0, status: 0 },
        // { id: 2, userName: 'Otilia', email: 'Xtremewnyhoney@gmail.com', couponTicketName: 'Christmas', pickUpTime: 1678344436103, useTime: 1678344436103, receiveSource: 1, status: 1 },
        // { id: 3, userName: 'Otilia', email: 'Xtremewnyhoney@gmail.com', couponTicketName: 'Christmas', pickUpTime: 1678344436103, useTime: 1678344436103, receiveSource: 2, status: 2 },
        // { id: 4, userName: 'Otilia', email: 'Xtremewnyhoney@gmail.com', couponTicketName: 'Christmas', pickUpTime: 1678344436103, useTime: 1678344436103, receiveSource: 3, status: 3 }
      ],
      total: 0,
      loading: false
    }
  },
  computed: {
    getReceiveSource() {
      return (type) => {
        switch (type) {
          case 0:
            return '手动发放'
          case 1:
            return '客户领取'
          case 2:
            return '定向发放：注册新用户'
          case 3:
            return '定向发放-资质注册'
          default:
            return '-'
        }
      }
    },
    getState() {
      return (type) => {
        switch (type) {
          case 0:
            return '可用'
          case 1:
            return '已使用'
          case 2:
            return '已过期'
          case 3:
            return '已作废'
          default:
            return '-'
        }
      }
    },
    defaultTips() {
      return (value) => value || '-'
    }
  },
  watch: {
    '$route.query.couponName': function(v) {
      if (v && v !== this.parameter.couponTicketName) {
        this.parameter.couponTicketName = this.$route.query.couponName
        this.getCustomerCouponsList()
      }
    }
  },
  created() {
    if (this.$route.query.couponName) {
      this.parameter.couponTicketName = this.$route.query.couponName // 优化券名称
      // this.$router.push({ query: {} })
    }
    this.getCustomerCouponsList()
  },
  methods: {
    /**
     * API 获取售后订单列表
     *
     * @param {Boolean} reset 是否重置分页
     */
    async getCustomerCouponsList(reset = true) {
      try {
        if (reset) {
          this.parameter.pageNumber = 1
        }
        this.loading = true
        let query = { ...this.parameter }
        delete query.dateType
        delete query.dataTime
        if (query.searchContent) {
          query.searchContent = query.searchContent.trim()
        }
        if (query.couponTicketName) {
          query.couponTicketName = query.couponTicketName.trim()
        }
        let { data } = await API.getCustomerCouponsList(query)
        this.total = data.total
        this.coupons = data.list
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },

    /**
     * API 作废客户优惠券
     *
     * @param {Object} query 请求参数对象
     */
    async stopUseCoupon(query) {
      let { code, message } = await API.stopUseCoupon(query)
      if (code === 10000) {
        this.getCustomerCouponsList()
        this.$message.success(message)
      } else {
        this.$message.error(message)
      }
    },

    /**
     * 时间日期选择器的回调事件
     *
     * @param {Array} date 日期数组
     */
    changeDatePicker(date) {
      if (date && date.length === 2) {
        this.parameter.pickUpTimeStar = date[0]
        this.parameter.pickUpTimeEnd = date[1]
      } else {
        this.parameter.pickUpTimeStar = undefined
        this.parameter.pickUpTimeEnd = undefined
      }
      this.getCustomerCouponsList()
    },

    /**
     * 停止客户用券
     *
     * @param {Object} row 当前点击的行数据
     */
    onStopCustomerCoupon(row) {
      this.$confirm(
        `<div>
            <p><strong style="color: #f56c6c;">注意</strong>：停用优惠券后，此券变为已作废状态，该客户将无法使用此优惠券，未免客户投诉，请提前周知客户，是否继续？</p>
          </div>`,
        '确认消息',
        {
          showClose: false,
          customClass: 'message-box',
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true,
          confirmButtonText: '确认停用',
          cancelButtonText: '取消'
        }
      )
        .then(() => {
          this.stopUseCoupon({ id: row.id, isVoid: 1 })
        })
        .catch(() => {
          this.$message.info('已放弃操作')
        })
    },

    /**
     * 每页显示数量发生改变时的回调
     *
     * @param size 每页显示数量
     */
    onSizeChange(size) {
      this.parameter.pageSize = size
      this.getCustomerCouponsList(false)
    },

    /**
     * 上一页/下一页/当前页发生改变时的回调
     *
     * @param current 当前页
     */
    onCurrentChange(current) {
      this.parameter.pageNumber = current
      this.getCustomerCouponsList(false)
    }
  }
}
</script>

<style lang="scss" scoped>
a {
  color: #99c41c;
  text-decoration: none;
  outline: none;
  &:hover {
    text-decoration: underline;
  }
}

.el-input {
  width: 280px;
}

.input-with-select {
  width: 400px;
  .el-select {
    width: 98px;
  }
  /deep/.el-input-group__prepend {
    background-color: #fff;
  }
}

.select-picker {
  display: inline-block;
  .el-select {
    width: 108px;
    /deep/.el-input__inner {
      border-right: 0;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
  }
  .el-range-editor.el-input__inner {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
  }
}
</style>
